import { useMemo, useCallback } from 'react';
import { isIframe } from '../utils';

const usePostMessage = parentOrigin => {
  const origin = useMemo(() => parentOrigin || window.location.origin, [parentOrigin]);
  const postMessage = useCallback((key, value) => {
    if (isIframe()) {
      window.parent.postMessage({
        message: key,
        value
      }, origin);
    }
  }, [origin]);
  return useMemo(() => {
    return {
      allowedParentOrigin: origin,
      postMessage,
      postExpandMessage: expand => postMessage('expand', expand),
      postLocaleMessage: locale => postMessage('locale', locale)
    };
  }, [postMessage, origin]);
};

export default usePostMessage;